import { useMemo, useEffect } from "react"
import PropTypes from "prop-types"
import { useNavigate } from "react-router-dom"
import { map } from "lodash"
import SearchableMenu from "components/searchable-menu"
import { getBaseComparisonTypes } from "helpers/comparison"
import { getGroup, menuContentSets } from "helpers/menu"
import { useIsOpPro } from "resources/account"
import { useLastRouterMatchProp, useRouterParam } from "hooks/router"
import { CONTENT_SET_METADATA } from "resources/content-sets"
import { useSaveContextPreferences } from "hooks/preferences"

function getPath(type) {
  if (type.path) {
    return type.path
  }

  if (type.isContentSet) {
    return `contentset/${type.id}`
  }

  return type.id
}

export default function CompareNavigation({ contentSets, setDownloadNameChunk }) {
  const navigate = useNavigate()
  const isOpPro = useIsOpPro()
  let selectedView = useLastRouterMatchProp("selectedView")
  const selectedContentSet = useRouterParam("contentSetId")
  if (selectedContentSet) {
    selectedView = selectedContentSet
  }

  const menuItems = useMemo(() => map([
    ...getBaseComparisonTypes(isOpPro),
    ...menuContentSets(contentSets),
  ], (type, i) => ({
    order: i,
    label: type.name,
    path: getPath(type),
    ...getGroup(type),
    ...type,
  })),
  [isOpPro, contentSets])

  const saveRouterPreference = useSaveContextPreferences("view")

  useEffect(() => {
    setDownloadNameChunk("view", menuItems.find(({ id }) => id === selectedView)?.label)
    return () => setDownloadNameChunk("view", null)
  }, [setDownloadNameChunk, menuItems, selectedView])

  // [TODO] This menu probably could be simplified a great deal
  return <SearchableMenu
    items={menuItems}
    current={selectedView}
    onSelect={(selectedItem) => {
      saveRouterPreference(selectedItem.path)
      navigate(`${selectedItem.path}${window.location.search}`)
    }}
  />
}

CompareNavigation.propTypes = {
  contentSets: PropTypes.arrayOf(CONTENT_SET_METADATA).isRequired,
  setDownloadNameChunk: PropTypes.func.isRequired,
}
